import { Helmet } from 'react-helmet-async';

interface MainProps {
  apiHost: string;
}

export default function Head({ apiHost }: MainProps): JSX.Element {
  return (
    <Helmet>
      <meta
        httpEquiv="Content-Security-Policy"
        content={`default-src 'self' https://*.adyen.com https://fonts.gstatic.com  ${apiHost}; img-src 'self' https://*.adyen.com ${apiHost}; style-src self 'unsafe-inline' https://fonts.googleapis.com ${apiHost}; frame-src https://*.adyen.com ${apiHost}; `}
      />
    </Helmet>
  );
}
